// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
(function() {

  // To show a toast use: Components.Utils.showToast
  Components.Toasts.ToastBase = createReactClass({

    propTypes: {
      toastView: PropTypes.element.isRequired,
      onClose: PropTypes.func,
      onClick: PropTypes.func,

      // Overrides
      shouldDismissAfterTime: PropTypes.bool,
      timeMs: PropTypes.number,
      width: PropTypes.number,
      clickToClose: PropTypes.bool,
      // Design System colors ie, "Blue", "GrayLightest" ...
      color: PropTypes.string,
      // "left", "center", or "right"
      horizontalAlign: PropTypes.oneOf(['center', 'left', 'right']),
      verticalAlign: PropTypes.oneOf(['top', 'bottom']),
      animate: PropTypes.bool
    },

    getDefaultProps: function(){
      return {
        clickToClose: true,
        color: "Blue",
        timeMs: 1200,
        shouldDismissAfterTime: true,
        horizontalAlign: "center",
        verticalAlign: "top",
        animate: true
      };
    },

    componentDidMount: function(){
      if (this.props.shouldDismissAfterTime){
        setTimeout(this.remove, this.props.timeMs);
      }
    },

    handleClick: function(e){
      if (this.props.clickToClose){
        this.remove();
      } else if (this.props.onClick){
        this.props.onClick(e);
      }
      e.preventDefault();
      e.stopPropagation();
    },

    remove: function(){
      this.props.onClose();
    },

    backgroundColor: function(){
      return "u-bgColor" + this.props.color
    },

    render: function() {
      var containerClasses = classNames(
        "Toast",
        "Toast--" + this.props.horizontalAlign,
        "Toast--" + this.props.verticalAlign,
        {"a-fadeInDown": this.props.animate},
      );
      var toastClasses = "u-ph6x u-pv2x Toast--content ";
      toastClasses += this.backgroundColor();
      return (
        <div
          className={containerClasses}
          aria-live="polite"
          role="alert"
          onClick={this.handleClick}
        >
          <div
            className={toastClasses}
            style={{
              width: this.props.width,
              borderRadius:"3px",
              boxShadow:"0 1px 3px rgba(0,0,0,0.2)"
            }}
          >
            {this.props.toastView}
          </div>
        </div>
      );
    },
  });

})();
